module.exports = __webpack_public_path__ + "static/media/367_celebartion_319_252-small.9c27d1e9.jpg";